/**
 * Scale that fits an authored-width document into the measured canvas width, never above 100%.
 * 0 while unmeasured: returning 1 would flash the document at full size for a frame before it snaps to fit.
 */
export function fitWidthScale(canvasWidth: number, docWidth: number, fitPadding = 0): number {

    if (!canvasWidth) return 0;
    return Math.min(1, (canvasWidth - fitPadding * 2) / docWidth);
}

/** Scale that fits the whole page in the canvas; falls back to fit-width until both heights are measured. */
export function fitPageScale(canvas: { width: number; height: number }, docWidth: number, docHeight: number, fitPadding = 0): number {

    if (!canvas.width || !canvas.height || !docHeight) return fitWidthScale(canvas.width, docWidth, fitPadding);
    const pad = fitPadding * 2;
    return Math.min(1, (canvas.width - pad) / docWidth, (canvas.height - pad) / docHeight);
}
